import UpdateMyTimesheet from "../components/UpdateMyTimesheet";
import useUpdateMyTimesheet from "../hooks/useUpdateMyTimesheet";

const UpdateMyTimesheetPage = () => {
    const useUpdateTimesheetProps = useUpdateMyTimesheet();

    return (
        <UpdateMyTimesheet {...useUpdateTimesheetProps} />
    )
}

export default UpdateMyTimesheetPage;